import React from 'react';

const TestTube = ({
  titleTag = 'TestTube',
  width = 16,
  fill = '#35348f',
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 24"
    style={{
      width,
      ...style,
    }}
  >
    {titleTag && <title>{titleTag}</title>}
    <path
      fill={fill}
      d="M1.9245 9.37839H6.38749C6.55113 9.37839 6.68502 9.53662 6.68502 9.73001V10.4332C6.68502 10.6266 6.55113 10.7849 6.38749 10.7849H1.9245V13.5978H6.38749C6.55113 13.5978 6.68502 13.756 6.68502 13.9494V14.6527C6.68502 14.846 6.55113 15.0043 6.38749 15.0043H1.9245V17.8172H6.38749C6.55113 17.8172 6.68502 17.9754 6.68502 18.1688V18.8721C6.68502 19.0655 6.55113 19.2237 6.38749 19.2237H1.9245V22.0366C1.9245 22.8102 2.46006 23.4431 3.11463 23.4431H12.6357C13.2902 23.4431 13.8258 22.8102 13.8258 22.0366V6.56545H1.9245V9.37839ZM14.1233 0.939575H1.62697C1.13604 0.939575 0.734375 1.41426 0.734375 1.99443V4.10413C0.734375 4.6843 1.13604 5.15898 1.62697 5.15898H14.1233C14.6143 5.15898 15.0159 4.6843 15.0159 4.10413V1.99443C15.0159 1.41426 14.6143 0.939575 14.1233 0.939575Z"
    />
  </svg>
);

export default TestTube;
